import "./Support.module.css";
import Header from "@/reusable_sections/Header";
import Service from "./sections/Service";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import HowItWorks from "./sections/HowItWorks";
import Process from "./sections/Process";
import NeemContactOp from "./sections/NeemContactOp";
import VoltGoFooter from "@/reusable_sections/Footer";
export default function SupportPage() {
  return <div>
      <Header />
      <Service />
      <FrequentlyAskedQuestions />
      <HowItWorks />
      <Process />
      <NeemContactOp />
      <VoltGoFooter />
    </div>;
}